import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/shared/Wrapper.jsx